import { getData, postData, putData } from "../../../services/api"


export const getCatalogsList = async () => {
    const res = await getData('dbms/itemcatalogs')
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getTypesList = async () => {
    const res = await getData('dbms/itemtypes')
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getBranchList = async () => {
    const res = await getData('dbms/branchs')
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getBudgetYearsList = async () => {
    const res = await getData('dbms/budget-years')
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}